import { useEffect, useRef } from 'react';

import {
  useAuthTelegramMutation,
  useLazyExtendedInfoQuery,
} from '@/api/queries/user';
import i18n from '@/i18n';
import { changeLoginRequesLoadingStatus } from '@/redux/reducers/appReducer';
import { changeOnboardingStatus } from '@/redux/reducers/userReducer';
import { useAppDispatch } from '@/redux/store';

const useAuthFromTelegram = (): void => {
  const [authUserFromTelegram] = useAuthTelegramMutation();
  const [getExtendedInfo] = useLazyExtendedInfoQuery();
  const hasRequestSend = useRef<boolean>(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const initDataIsExist = !!Telegram?.WebApp?.initData;

    if (initDataIsExist && !hasRequestSend.current) {
      // for dev env, prevent dublicate request
      hasRequestSend.current = true;
      authUserFromTelegram()
        .unwrap()
        .then((response) => {
          dispatch(changeOnboardingStatus(true));
          sessionStorage.setItem(
            'start-point-balance',
            String(response.balance.point),
          );
          getExtendedInfo();
          i18n.changeLanguage(response.language);
        })
        .finally(() => dispatch(changeLoginRequesLoadingStatus(false)));
    }
  }, []);
};

export { useAuthFromTelegram };
